export const getBatteryEnergyHeight = (energy: number): number => {
    return (160 / 100) * energy;
};
